import "./IconButtons.css";

const IconButtons = ({className, title, buttons}) => {
    return (
        <div className={className}>
            {title &&
                <div className="text-center">
                    <h3>{title}</h3>
                </div>
            }
            <div className="remoteAdminIconButtonContainer ">
                { buttons.map(button =>
                    <div onClick={() => button.onClick()}>
                        <div className="remoteAdminIconButton">
                            {button.icon}
                        </div>
                        <div className="remoteAdminIconButtonUnder">
                            {button.under}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default IconButtons;